import {Envelope} from "../gameobjects/Envelope";
import {LevelNumber} from "./LevelModel";
import {Location} from "./Location";

export interface IMatch2ScreenData {
    location: Location;
    level: LevelNumber;
    envelope?: Envelope;
    fromStartScreen?: boolean;
    bgm?: string;
}

export const DefaultMatch2screenData: Readonly<IMatch2ScreenData> = {
    location: Location.Rio,
    level: 1,
};
